(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }

        function formatPrice (price) {
          return `€${price.toFixed(2).replace('.', ',')}`
        }

        $('.product-upsell__variant-selector-value').on('click', function () {
          const el = $(this)

          const productId = el.attr('data-product-id')

          if (disabledProducts[productId]) {
            return
          }
          const variant = JSON.parse(el.attr('data-variant'))
          if (!variant.available) {
            return
          }
          console.log(variant, productId)

          $(`.product-upsell__variant-selector-value-active[data-product-id="${productId}"]`).addClass('product-upsell__variant-selector-value-inactive')
          $(`.product-upsell__variant-selector-value-active[data-product-id="${productId}"]`).removeClass('product-upsell__variant-selector-value-active')
          $(`.product-upsell__variant-selector-value[data-variant-id="${variant.id}"][data-product-id="${productId}"]`).addClass('product-upsell__variant-selector-value-active')
          $(`.product-upsell__variant-selector-value[data-variant-id="${variant.id}"][data-product-id="${productId}"]`).removeClass('product-upsell__variant-selector-value-inactive')

          selectedUpsells[productId] = variant.id

          // Set price
          if (variant.compare_at_price !== null && variant.compare_at_price !== 0 && variant.compare_at_price !== variant.price) {
            $(`.price--compare[data-product-id="${productId}"]`).text(formatPrice(variant.compare_at_price / 100))
            $(`.price--large[data-product-id="${productId}"]`).text(formatPrice(variant.price / 100))

            const percentage = Math.floor(100 - ((variant.price / variant.compare_at_price) * 100))
            console.log(percentage)
            $(`.upsell-sale-badge[data-product-id="${productId}"]`).text(`-${percentage}%`)

            $(`.price-list-multi[data-product-id="${productId}"]`).show()
            $(`.price-list-solo[data-product-id="${productId}"]`).hide()
          } else {
            $(`.price-list-multi[data-product-id="${productId}"]`).hide()
            $(`.price-list-solo[data-product-id="${productId}"]`).show()
            console.log(`.price-list-solo > .price[data-product-id="${productId}"]`)
            $(`.price-list-solo > .price[data-product-id="${productId}"]`).text(formatPrice(variant.price / 100))
          }
        })

        $('.product-upsell__add-to-cart').on('click', function () {
          const el = $(this)
          const productId = el.attr('data-product-id')
          const upsellVariantId = selectedUpsells[productId]
          console.log(productId, upsellVariantId)

          try {
            window['ablyft'] = window['ablyft'] || [];
            window['ablyft'].push({
                eventType: 'custom',
                eventName: 'upsell-popup-in-den-warenkorb',
                eventValue: 1
            }); 
          } catch (e) {
            
          }
          if (addVariants.includes(upsellVariantId)) {
            // enable button
            addVariants.splice(addVariants.indexOf(upsellVariantId), 1)
            el.removeClass('product-upsell__add-to-cart-active')
            el.text('In den Warenkorb')

            disabledProducts[productId] = false
          } else {
            // disable button
            addVariants.push(upsellVariantId)
            el.text('✓ Hinzugefügt')
            el.addClass('product-upsell__add-to-cart-active')
            disabledProducts[productId] = true
          }
        })

        // set default variants

        $('.upsell-popup__default-variant').each(function () {
          const el = $(this)
          const productId = el.attr('data-product-id')
          const variantId = Number.parseInt(el.attr('data-default-variant-id'))

          selectedUpsells[productId] = variantId
        })

        const closePopup = () => {
          console.log(addVariants)
          // add variants to cart

          // add base product
          const href = window.location.href
          let variantId = href?.split('variant=')?.[1]?.split('&')?.[0]

          const baseProduct = JSON.parse($('#base-product').attr('data-product'))

          console.log(baseProduct)
          if (variantId) {
            variantId = Number.parseInt(variantId)
          } else {
            variantId = baseProduct.variants.find(v => v.available).id
          }

          const items = [{
            id: variantId,
            quantity: 1
          }]
          
          for (const variantId of addVariants) {
            items.push({
              id: variantId,
              quantity: 1
            })
          }

          console.log(items)
          $.post('/cart/add', {
            items
          }, () => {
            console.log('ADDED ')

            $('.quickbuy-popup-wrapper').hide()

            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));

            $('a[href="/cart"]').attr('aria-expanded', 'true')
          })
        }
        $('#popup-upsell-continue').on('click', function () {
          // add upsell products to cart
          try {
            window['ablyft'] = window['ablyft'] || [];
          window['ablyft'].push({
              eventType: 'custom',
              eventName: 'upsell-popup-weiter-zum-warenkorb',
              eventValue: 1
          });
          } catch (e) {
              
          }
          closePopup()
        })

        $('.product-upsell__close').on('click', function () {
          closePopup()
        })

        ratingSnippet("ruk_rating_snippet", {
          store: "magicholz.de",
          mode: "default",
          color: "#ffca45",
          linebreak: false,
          text: "",
          singularText: "",
          lang: "de-in",
          usePolaris: false,
          showEmptyStars: false,
        });

        $('.quickbuy-popup-wrapper').on('click', function (e) {
          if(e.target !== e.currentTarget) return;
          closePopup()
        })
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
      })();
